import * as React from 'react';

import { IGeoValue } from '../types';

export interface IUseOnItemClick {
  geoValues: IGeoValue[];

  clearSuggestValue(): void;

  onGeoValuesChange(items: IGeoValue[]): void;
}

export const useGeoTagsItemClick = ({ clearSuggestValue, onGeoValuesChange, geoValues }: IUseOnItemClick) => {
  return React.useCallback(
    (item: IGeoValue) => {
      clearSuggestValue();

      const hasValue = geoValues.some(({ title }) => item.title === title);

      if (!hasValue) {
        onGeoValuesChange([item, ...geoValues]);
      }
    },
    [clearSuggestValue, onGeoValuesChange, geoValues],
  );
};
